if (!customElements.get('bertic-last-viewed-products')) {
  customElements.define(
    'bertic-last-viewed-products',
    class BerticLastViewedProducts extends HTMLElement {
      static STORAGE_KEY = 'berticdesigns_last_viewed_products';
      // Indépendant du réglage de la section, qui varie d'un template à l'autre ; +1 pour le produit en cours, exclu de l'affichage
      static MAX_STORED = 11;

      connectedCallback() {
        this.currentId = this.dataset.productId;
        if (this.currentId) this.storeCurrentProduct();
        this.displayProducts();
      }

      // Entrées { id, handle } : l'id identifie le produit quelle que soit la langue (le handle peut être traduit),
      // le handle sert à récupérer la carte
      readProducts() {
        try {
          const stored = JSON.parse(localStorage.getItem(BerticLastViewedProducts.STORAGE_KEY) ?? '[]');
          // Les entrées d'anciens formats sont ignorées
          return Array.isArray(stored)
            ? stored.filter((product) => typeof product?.id === 'string' && typeof product?.handle === 'string')
            : [];
        } catch (error) {
          return [];
        }
      }

      writeProducts(products) {
        try {
          localStorage.setItem(BerticLastViewedProducts.STORAGE_KEY, JSON.stringify(products));
        } catch (error) {
          // Stockage indisponible (navigation privée, quota) : la section ne s'affiche simplement pas
        }
      }

      // Du plus récent au plus ancien : un produit revu remonte en tête, avec le handle de la langue courante
      storeCurrentProduct() {
        const products = this.readProducts().filter((product) => product.id !== this.currentId);
        products.unshift({ id: this.currentId, handle: this.dataset.productHandle });
        this.writeProducts(products.slice(0, BerticLastViewedProducts.MAX_STORED));
      }

      async displayProducts() {
        const products = this.readProducts()
          .filter((product) => product.id !== this.currentId)
          .slice(0, parseInt(this.dataset.productsToShow, 10));

        if (!products.length) return this.removeSection();

        const rootUrl = this.dataset.rootUrl.replace(/\/$/, '');
        const cards = await Promise.all(products.map((product) => this.fetchCard(rootUrl, product.handle)));

        // Produits supprimés ou dépubliés (404) : retirés de l'historique ; une erreur réseau ne retire rien
        const missingIds = products.filter((product, index) => cards[index] === null).map((product) => product.id);
        if (missingIds.length) {
          this.writeProducts(this.readProducts().filter((product) => !missingIds.includes(product.id)));
        }

        const grid = this.querySelector('.grid');
        cards.filter(Boolean).forEach((card) => {
          const item = document.createElement('li');
          item.className = 'grid__item';
          item.append(card);
          grid.append(item);
        });

        if (grid.children.length) {
          this.hidden = false;
        } else {
          this.removeSection();
        }
      }

      removeSection() {
        (this.closest('.shopify-section') ?? this).remove();
      }

      async fetchCard(rootUrl, handle) {
        try {
          const productUrl = `${rootUrl}/products/${encodeURIComponent(handle)}`;
          let response = await fetch(`${productUrl}?section_id=bertic-product-card`);
          if (response.status === 404) return null;

          if (!response.ok) {
            // Handle d'une autre langue : Shopify redirige la page vers le handle traduit, mais pas la requête de section
            const page = await fetch(productUrl, { method: 'HEAD' });
            if (page.status === 404) return null;
            if (!page.ok || !page.redirected) return undefined;

            const translatedUrl = new URL(page.url).pathname.replace(/\/$/, '');
            response = await fetch(`${translatedUrl}?section_id=bertic-product-card`);
            if (!response.ok) return undefined;
          }

          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          return html.querySelector('.card-wrapper') ?? undefined;
        } catch (error) {
          return undefined;
        }
      }
    }
  );
}
